<script lang="ts" setup>
import { showErrorPage } from '~/utils/showErrorPage'

/**
 * This component is the page component responsible for rendering blog routes.
 * It renders the content under the /content directory that matches the given
 * route.
 *
 * @see: https://content.nuxt.com/components/content-doc#slots
 */
definePageMeta({
  showNotificationBar: false,
  showFullFooter: false,
  // Setting this to true sets the main content pane to a blank slate without
  // container styles. This allows the blog page to accommodate the content
  // that is flush to header, footer, or edges of the main pane.
  containsFlushContent: true,
})

const route = useRoute()
// Note: entry-specific front matter is specified via the /content entry.
// The canonical link depends on the route, rather than the entry, so we specify
// it here.
useHead({
  link: [
    {
      rel: 'canonical',
      href: `https://grove.co${route.path}`,
    },
  ],
})
</script>

<template>
  <NuxtLayout>
    <ContentDoc :path="route.path">
      <template #default="{ doc }">
        <div class="BlogPage_Layout">
          <ContentfulContent :entries="doc.widgets" />
        </div>
      </template>
      <template #not-found>
        {{
          showErrorPage(`Corresponding document not found for ${route.path}`)
        }}
      </template>
    </ContentDoc>
  </NuxtLayout>
</template>

<style lang="scss">
// CS-442: Update styling to accommodate full span widgets:
// Right now this styling equivalent of default layout with containsFlushContent: false.
.BlogPage_Layout {
  @include container-small;
  max-width: 100vw;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: var(--spacing-12x);
  margin-bottom: var(--spacing-12x);

  @include for-medium-up {
    --container-max: #{$container-medium};
  }

  @include for-large-up {
    --container-max: #{$container-large};
  }
}
</style>
